import { Component, EventEmitter, Output } from '@angular/core';
import { KpiFilters } from '../../models/kpi-filters.model';
import { PlantFilterSelectionChange } from '../../shared/components/plant-filters/plant-filters.component';

@Component({
  selector: 'app-kpi-filters',
  templateUrl: './kpi-filters.component.html',
  styleUrl: './kpi-filters.component.scss',
  standalone: false,
})
export class KpiFiltersComponent {
  @Output() filtersChanged = new EventEmitter<KpiFilters>();

  onFilterSelectionChange(change: PlantFilterSelectionChange): void {
    this.filtersChanged.emit({
      plant: change.plant,
      plannerGroups: change.plannerGroups,
      workCenters: change.workCenters,
    });
  }
}
